import React from 'react';

const NotFoundPage = () => {
  return <div>에러페이지입니당 </div>;
};

export default NotFoundPage;
